import { BADGE, BADGE_COLORS } from './helper';

const Row = ({ icon: Icon, iconClass, title, badge = '', badgeColor = 'blue', meta, children = null, action }) => (
  <div className="flex flex-wrap items-center gap-x-3.5 gap-y-3 px-4 py-4 sm:px-5">
    <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${iconClass}`}>
      <Icon size={20} />
    </span>

    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <p className="text-sm font-bold text-secondary-900">{title}</p>
        {badge && <span className={`${BADGE} ${BADGE_COLORS[badgeColor]}`}>{badge}</span>}
      </div>

      <p className="mt-0.5 break-words text-[13px] text-secondary-500">{meta}</p>

      {children}
    </div>

    <div className="flex basis-full items-center gap-3 pl-[58px] sm:basis-auto sm:pl-0">{action}</div>
  </div>
);

export default Row;
